export default {
  findWeekOrders: `query findWeekOrders($startDate: String!, $endDate: String!, $office: Int! ) {
    findWeekOrders(
      startDate: $startDate,
      endDate: $endDate,
      office: $office,
    ) {
      id,
      user,
      userInfo {
        name,
        email
      },
      menuEvent,
      meal,
      menuInfo {
        event,
        date,
        office
      },
      mealInfo {
        name,
        dietInfo {
          id,
          name
        }
      },
    },
  }`,
  findWeekOrdersByCountry: `query findWeekOrdersByCountry($startDate: String!, $endDate: String!, $country: String! ) {
    findWeekOrdersByCountry(
      startDate: $startDate,
      endDate: $endDate,
      country: $country,
    ) {
      id,
      user,
      userInfo {
        name,
        email
      },
      menuEvent,
      meal,
      menuInfo {
        event,
        date,
        office
      },
      mealInfo {
        name,
        dietInfo {
          id,
          name
        }
      },
    },
  }`,
  findWeekOrdersByUser: `query findWeekOrdersByUser($startDate: String!, $endDate: String!, $office: Int! ) {
          findWeekOrdersByUser(
            startDate: $startDate,
            endDate: $endDate,
            office: $office,
          ) {
            id,
            user,
            userInfo {
              name,
            },
            menuEvent,
            meal,
            menuInfo {
              event,
              date,
              office
            },
            mealInfo {
              name,
              dietInfo {
                id,
                name
              }
            },
          },
        }`,
  findOrdersByUser: `query findOrdersByUser($startDate: String!, $endDate: String!, $office: Int! ) {
          findOrdersByUser(
            startDate: $startDate,
            endDate: $endDate,
            office: $office,
          ) {
            id,
            user,
            userInfo {
              name,
            },
            menuEvent,
            meal,
            menuInfo {
              event,
              date,
              office
            },
            mealInfo {
              name,
              dietInfo {
                id,
                name
              }
            },
          },
        }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/order.js